import {Base, model, belongsTo, hasMany, endpoint} from '@scoutgg/ftw/source/lib/model'
import positions from '../../helpers/positions'

@model('Player')
@endpoint('players', {root: '/api'})
@belongsTo('team')
@hasMany('seasons')
@hasMany('playerSources')
export class Player extends Base {
  get fullName() {
    if(this.customName && this.firstName) {
      return `${this.firstName} "${this.customName}" ${this.lastName}`
    } else if(this.lastName && this.firstName) {
      return `${this.firstName} ${this.lastName}`
    } else {
      return this.lastName
    }
  }
  get formalName() {
    var ret = [this.lastName, this.firstName].join(', ')
    if(this.customName) ret += ` (${this.customName})`
    return ret
  }
  get name() {
    return this.customName || this.lastName || '<unnamed player>'
  }
  get pos() {
    return positions[this.position] ||
      (this.position || '?').slice(0, 3).toUpperCase()
  }
  get teamName() {
    return (this.team && this.team.name) || ''
  }
}
